import { Component, OnInit } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { BiometricService } from 'src/app/services/biometric/biometric.service';

@Component({
  selector: 'app-popover-biometric',
  templateUrl: './popover-biometric.component.html',
  styleUrls: ['./popover-biometric.component.scss'],
})

export class PopoverBiometricComponent implements OnInit {

  public title: string;
  public description: string;
  public accept_label: string;
  public cancel_label: string;
  public feedbackExperienceDlg: any = [];
  public biometricStatus: boolean = true;
  public isBoydCardConnected: boolean = false;
  constructor(
    private readonly configService: ConfigService,
    private readonly navigator: Navigator,
    private biometricService:BiometricService,
    private eventsService:EventsService
  ){}

  

  ngOnInit(): void {
    let data = this.navigator?.activePopovers[this.navigator.activePopovers.length-1]?.componentProps?.data;
    console.log(data);
    this.biometricStatus = !data.biometricStatus;
    this.isBoydCardConnected = data.isBoydCardConnected;
    this.feedbackExperienceDlg = this.configService.getConfig().FEATURE_FACEID_CONFIG_DLG ? 
                                JSON.parse(this.configService.getConfig().FEATURE_FACEID_CONFIG_DLG ):
                                [{title_email_switch_on:"You're about to activate Biometric/Face ID", 
                                description_email_switch_on:"Occasionally, we'll prompt you to log in using your email address and password", 
                                title_boyd_switch_on:"You're about to activate Biometric/Face ID", 
                                description_boyd_switch_on:"We'll occasionally ask you to log in using your Boyd Rewards online credentials", 
                                accept_label:"OK", 
                                cancel_label:"Cancel",
                                title_email_switch_off:"Disable Biometric/Face ID log in?", 
                                description_email_switch_off:"If you proceed, you won't be able to log in using Biometric/Face ID. To re-enable, you'll need to log in with your email address and password", 
                                title_boyd_switch_off:"Turn off Biometric/Face ID log in?", 
                                description_boyd_switch_off:"If you proceed, you won't be able to log in using Biometric/Face ID. To re-enable, you'll need to log in with your Boyd Rewards account credentials",} ] ;
    if(this.isBoydCardConnected){
      this.title = this.biometricStatus?this.feedbackExperienceDlg[0].title_boyd_switch_on:this.feedbackExperienceDlg[0].title_boyd_switch_off;
      this.description = this.biometricStatus?this.feedbackExperienceDlg[0].description_boyd_switch_on:this.feedbackExperienceDlg[0].description_boyd_switch_off;
    } else {
      this.title = this.biometricStatus?this.feedbackExperienceDlg[0].title_email_switch_on:this.feedbackExperienceDlg[0].title_email_switch_off;
      this.description = this.biometricStatus?this.feedbackExperienceDlg[0].description_email_switch_on:this.feedbackExperienceDlg[0].description_email_switch_off;
    }
    this.accept_label = this.feedbackExperienceDlg[0].accept_label;
    this.cancel_label = this.feedbackExperienceDlg[0].cancel_label;  
  }

  public updateBiometric(status){
    this.biometricService.setBiometricStatus(status);
    let loginInfo = JSON.parse(localStorage.getItem('logininfo'));
    if(loginInfo){
      this.biometricService.setCredentials(loginInfo);
    }
    this.eventsService.publish('event:biometric:toggleresult',{"toggleresult":true});
    this.dismissCurrentPopover();
  }

  public cancelSwitch = () => {
    this.eventsService.publish('event:biometric:toggleresult',{"toggleresult":false});
    this.dismissCurrentPopover();
  }

  public acceptSwitch(){
    this.updateBiometric(this.biometricStatus);
  }

  private dismissCurrentPopover(){
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
  }
}
